import { useCallback } from "react";
import { SetterOrUpdater, useRecoilState } from "recoil";
import {
  providerState,
  defaultRequisitions,
  defaultReqsRequestComplete,
  orderedReqsRequestComplete,
  providerEmailNotificationFrequency,
  providerProfileState,
  loggedOutDueToInactivity,
} from "../../recoil/atoms";
import { Auth0UserSerializer } from "../../recoil/types";
import { removeCookieAccessToken } from "../requestUtils";
import { CFC_ELIGIBILITY_ALERT_AUTO_OPENED_SESSION_KEY } from "../../components/Cfc/constants";

interface LogoutHook {
  auth: Auth0UserSerializer | undefined;
  setLoggedOut: (inactivity: boolean) => void;
  loggedOutInactivityFlag: boolean;
  setLoggedOutInactivityFlag: SetterOrUpdater<boolean>;
  setProviderAuth: SetterOrUpdater<Auth0UserSerializer | undefined>;
}
export const useAuthenticationHook = (): LogoutHook => {
  const [auth, setProviderAuth] = useRecoilState(providerState);
  const [, setRequisitions] = useRecoilState(defaultRequisitions);
  const [, setDefaultReqsComplete] = useRecoilState(defaultReqsRequestComplete);
  const [, setOrderedReqsComplete] = useRecoilState(orderedReqsRequestComplete);
  const [, setNotificationFrequency] = useRecoilState(
    providerEmailNotificationFrequency,
  );
  const [, setProfile] = useRecoilState(providerProfileState);
  const [loggedOutInactivityFlag, setLoggedOutInactivityFlag] = useRecoilState(
    loggedOutDueToInactivity,
  );

  const setLoggedOut = useCallback(
    (inactivity: boolean) => {
      removeCookieAccessToken();
      sessionStorage.removeItem("current-pathname");
      sessionStorage.removeItem(CFC_ELIGIBILITY_ALERT_AUTO_OPENED_SESSION_KEY);
      localStorage?.removeItem(`btoProviderCurrentPageCOMPLETED`);
      localStorage?.removeItem(`btoProviderCurrentPagePROCESSING`);
      localStorage?.removeItem(`btoProviderColumnStateCOMPLETED`);
      localStorage?.removeItem(`btoProviderColumnStatePROCESSING`);
      localStorage?.removeItem(`btoProviderCurrentTab`);
      setProviderAuth(undefined);
      setRequisitions(undefined);
      setNotificationFrequency(undefined);
      setProfile(undefined);
      setDefaultReqsComplete(false);
      setOrderedReqsComplete(false);
      if (inactivity) {
        setLoggedOutInactivityFlag(true);
      }
    },
    [
      setDefaultReqsComplete,
      setLoggedOutInactivityFlag,
      setNotificationFrequency,
      setOrderedReqsComplete,
      setProfile,
      setProviderAuth,
      setRequisitions,
    ],
  );

  return {
    auth,
    setLoggedOut,
    loggedOutInactivityFlag,
    setLoggedOutInactivityFlag,
    setProviderAuth,
  };
};
